import { useState } from "react";
import { toast } from "sonner";
import { Eye, EyeOff } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

export default function RevealPayout({ expense }) {
  const { authAxios } = useAuth();
  const [full, setFull] = useState(null);
  const isPaypal = expense.payout_method === "paypal";
  const masked = isPaypal ? expense.payout_paypal_id : expense.iban;
  if (!masked) return <p><strong>{isPaypal ? "PayPal" : "IBAN"}:</strong> —</p>;
  const reveal = async () => {
    if (full) return setFull(null);
    try {
      const r = await authAxios.get(`/expenses/${expense.id}/payout-reveal`);
      setFull((isPaypal ? r.data.paypal_id : r.data.iban) || masked);
    } catch (e) { toast.error(e.response?.data?.detail || "Could not reveal"); }
  };
  return (
    <p className="flex items-center gap-1.5 flex-wrap">
      <strong>{isPaypal ? "PayPal" : "IBAN"}:</strong>
      <span className="font-mono" data-testid={`payout-value-${expense.id}`}>{full || masked}</span>
      <button type="button" onClick={(ev) => { ev.stopPropagation(); reveal(); }} className="text-[#1e3a5f] underline flex items-center gap-0.5" data-testid={`payout-reveal-${expense.id}`}>
        {full ? <><EyeOff className="w-3 h-3" /> Hide</> : <><Eye className="w-3 h-3" /> Reveal</>}
      </button>
    </p>
  );
}
